import React, { useCallback, useMemo } from 'react'

import Tooltip from '../../../../components/Tooltip'
import ButtonIcon from '../../../../features/components/Buttons/ButtonIcon'

import { fileTypes } from '../helpers'

import useGetAccessibleUrl from '../../../../features/hooks/useGetAccessibleUrl'

const RightFilesTooltips = ({ files, fileIconClassName, handleManageFilesClick, rightId }) => {
  const { isAccessibleUrlLoading, handleFileDownloading, fileUrl: requestedUrl } = useGetAccessibleUrl()

  const filesGroupedByType = useMemo(() => {
    const groups = []

    files.forEach(file => {
      const fileType = file.right_file_type
      const group = groups.find(groupItem => groupItem.find(fileItem => fileItem.right_file_type === fileType))

      if (group) {
        group.push(file)
      } else {
        groups.push([file])
      }
    })

    return groups
  }, [files])

  const handleFileTooltipClick = useCallback(
    (group, fileUrl) => {
      if (group.length > 1) {
        handleManageFilesClick(rightId)
      } else {
        handleFileDownloading(fileUrl)
      }
    },
    [handleManageFilesClick, handleFileDownloading, rightId]
  )

  return filesGroupedByType.map((group, index) => {
    const fileUrl = group[0].document
    const fileTypeDetails = fileTypes[group[0].right_file_type]
    const IconImage = fileTypeDetails.icon
    const isLoading = fileUrl === requestedUrl && isAccessibleUrlLoading

    return (
      <Tooltip
        triggerElement={
          <ButtonIcon
            Icon={IconImage}
            className={fileIconClassName}
            isLoading={isLoading}
            // get accessible url and then:
            // open file in new tab either download for unsupported file types by browsers
            onClick={() => handleFileTooltipClick(group, fileUrl)}
          />
        }
        key={index}
      >
        {fileTypeDetails.label}
      </Tooltip>
    )
  })
}

export default RightFilesTooltips
